// extracted by mini-css-extract-plugin
module.exports = {"loadingWrapper":"App_loadingWrapper__OTnrg","App-logo":"App_App-logo__1GLNd","App-logo-spin":"App_App-logo-spin__1EbLw"};